<template>
<div>
	<header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<!-- <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
					aria-label="Open navigation menu">menu</button>-->
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<!-- <div class="profile d-flex align-items-center mgr-24"><img src="images/avtar.svg"
						class="w-32 h-32 circle mgr-16" alt="">
					<div class="t-body2 t-color-white">USER ID</div>
				</div> -->
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click="login" @keypress="login" tabindex="0">{{$t('3323')}}</div>
				<!-- <div class=" t-body2 t-color-appbarText pdr-18 cursor-pointer">LOGOUT</div> -->
			</section>
		</div>
	</header>
<div class="d-flex h-full flex-column">
<main class="main-wrapper full flex-grow-1 scroll-y">
<div class="container container--small pdt-50">
<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('1213')}}</div>
<div class="t-body1 t-color-bodyGrayA font-r mgt-8 pdl-24 pdr-24">{{$t('1214')}}</div>
<div class="mdc-card  mgt-24 mgl-24 mgr-24 mgb-16">
<div class="pdt-24 pdl-24 pdb-24 pdr-16">
<div class="mdc-form-field  d-flex w-full flex-row-reverse checkbox-rtl">
		<div class="mdc-checkbox">
						<input type="checkbox" class="mdc-checkbox__native-control"
						id="checkbox-1"
						v-model="checkTerms"
						@change="handleCheckAll1" />
						<div class="mdc-checkbox__background check-red">
										<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
														<path class="mdc-checkbox__checkmark-path" fill="none"
																		d="M1.73,12.91 8.1,19.28 22.79,4.59" />
										</svg>
										<div class="mdc-checkbox__mixedmark"></div>
						</div>
						<div class="mdc-checkbox__ripple"></div>
		</div>
		<label for="checkbox-1"><router-link tabindex="0" to="/terms" class="pdt-2 font-m t-subtitle3 pdl-0 t-color-headlineBlack">{{$t('1215')}}</router-link></label>
</div>
<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26 h-60 scroll-y cursor--pointer" @click="gotoPage('terms')" @keypress="gotoPage('terms')" v-html="htmlTermsOfService" tabindex="0"></div>
<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26">
  {{$t('178')}} : {{termsDate}}
</div>
</div>
</div>
<div class="mdc-card  mgt-24 mgl-24 mgr-24 mgb-16">
<div class="pdt-24 pdl-24 pdb-24 pdr-16">
<div class="mdc-form-field  d-flex w-full flex-row-reverse checkbox-rtl">
		<div class="mdc-checkbox">
						<input type="checkbox" class="mdc-checkbox__native-control" id="checkbox-2"
						v-model="checkPrivacy"
            @change="handleCheckAll2" />
						<div class="mdc-checkbox__background check-red">
										<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
														<path class="mdc-checkbox__checkmark-path" fill="none"
																		d="M1.73,12.91 8.1,19.28 22.79,4.59" />
										</svg>
										<div class="mdc-checkbox__mixedmark"></div>
						</div>
						<div class="mdc-checkbox__ripple"></div>
		</div>
		<label for="checkbox-2"><router-link tabindex="0" to="/privacy" class="pdt-2 font-m t-subtitle3 pdl-0 t-color-headlineBlack">{{$t('1216')}}</router-link></label>
</div>
<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26 h-60 scroll-y cursor--pointer" @click="gotoPage('privacy')" @keypress="gotoPage('privacy')" v-html="htmlPrivacypolicy" tabindex="0">
</div>
<div class="mgt-16 t-body3 font-r t-color-bodyGrayA t-line-h-26">
  {{$t('179')}} : {{privacyDate}}
</div>
</div>
</div>
<div class="mgt-16 pdl-24 pdr-16">
<div class="mdc-form-field  d-flex w-full flex-row-reverse checkbox-rtl">
<div class="mdc-checkbox">
		<input type="checkbox" class="mdc-checkbox__native-control" id="checkbox-3"
				v-model="checkAll"
				@change="handleCheckAll"
				:checked="validAgree"
		 />
		<div class="mdc-checkbox__background check-red">
						<svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
										<path class="mdc-checkbox__checkmark-path" fill="none"
														d="M1.73,12.91 8.1,19.28 22.79,4.59" />
						</svg>
						<div class="mdc-checkbox__mixedmark"></div>
		</div>
		<div class="mdc-checkbox__ripple"></div>
</div>
<label for="checkbox-3" class="font-m t-subtitle3 mgr-16">{{$t('1602')}}</label>
</div>
</div>
	<div class="mgt-50 mgb-50 pdl-24">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText" @click="next()" @keypress="next()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1218')}}</span>
			</button>
	</div>
</div>
</main>
</div>
</div>
</template>

<script>
/**
 * 회원가입 - 약관동의 컴포넌트(sign up - pp & tnu component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select';
import {MDCFormField} from '@material/form-field'
import {MDCRadio} from '@material/radio'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../../mixins/topAppBar.js'
import memberApi from '@/api/memberApi.js'
import loginApi from "@/api/loginApi.js"
import popupApi from "@/api/popupApi.js"
import localStorageUtil from "@/utils/localStorageUtil";
import { userMixin } from "@/mixins/user";

export default {
	data() {
		return {
			checkTerms: false,
			checkPrivacy: false,
			checkAll: false,
			htmlPrivacypolicy: null,
			htmlTermsOfService: null,
			termsYear: '',
			termsMonth: '',
			termsDay: '',
			privacyYear: '',
			privacyMonth: '',
			privacyDay: '',
			params: "",
			redirectPath: "",
			popupData: null,
			popupImage: null,
			socialFirstName: "",
			socialLastName: "",
			socialFullName: "",
			socialEmail: "",
			socialAuth: false,
			isDrawerOpen: false,
			staticMode: '',
			title: null,
      isIdpService: localStorageUtil.isIdpServiceValidate()
		}
	},

	mixins: [joinMixin,topAppBarMixin,userMixin],

	components: {
		TopAppBar
	},

	watch: {
		'$route' (to, from) {
		   this.params = JSON.parse(localStorage.getItem("userParams"));
		   this.setTopAppBarCloseOnly('')
		}
	},

	created() {
		// Redirect URL
		this.title = localStorage.getItem('brandName') || this.$t('1213')
	},


	mounted() {
		this.params = JSON.parse(localStorage.getItem("userParams"));
		// get terms & privacy contents
		this.setMaterialUi()
		joinApi.terms().then((response) => {
			const termsUrl = response.data.data.TERMS_OF_SERVICE;
			const privacyUrl = response.data.data.PRIVACY_STATEMENT;

			joinApi.policyContents(termsUrl,'text').then((response) => {
				this.htmlTermsOfService = response.data
			})

			joinApi.policyContents(privacyUrl,'text').then((response) => {
				this.htmlPrivacypolicy = response.data
			})
		}).catch((err) => {
		})
		let privacyParams = {type:'PRIVACY_STATEMENT'};
		joinApi.termsDate(privacyParams).then((response) => {
			if(response.data.data){
        this.privacyDate = this.$moment(response.data.data).format("L")
				this.privacyYear = this.$moment(response.data.data).format("Y");
				this.privacyMonth = this.$moment(response.data.data).format("MM");
				this.privacyDay = this.$moment(response.data.data).format("DD");
			}
		}).catch((err) => { console.log('err=>',err)})
				let termsParams = {type:'TERMS_OF_SERVICE'};
		joinApi.termsDate(termsParams).then((response) => {
			if(response.data.data){
        this.termsDate = this.$moment(response.data.data).format("L")
				this.termsYear = this.$moment(response.data.data).format("Y");
				this.termsMonth = this.$moment(response.data.data).format("MM");
				this.termsDay = this.$moment(response.data.data).format("DD");
			}
		}).catch((err) => { console.log('err=>',err)})
	},

	computed: {
		...mapState('join',{
			join : state => state,
		}),

		validAgree() {
			this.checkAll = this.checkTerms && this.checkPrivacy
			return this.checkAll
		}
	},


	methods: {
		gotoPage(routerLink) {
		  this.$router.push(routerLink);
		},

		login() {
      if (this.isIdpService) {
        this.$moveIdpLogout();
      } else {
        this.$router.push("/login");
      }
		},
		// Store 변이 정의(define store mutation)
		...mapMutations("join", [
			"SET_TERMS",
			"SET_JOINSTART",
			"SET_SOCIAL_LINK",
			"SET_PUSH_NOTIFICATION",
			"SET_NAME_FIRST",
			"SET_NAME_LAST",
			"SET_NAME_FULL",
			"SET_LOGINID",
			"SET_SOCIAL_ID",
			"INIT_JOIN_STORE",
			]),

		...mapMutations("dormancy", ["MUTATION_USER_DATA"]),

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		handleCheckAll1() {
			this.checkTerms
			this.checkPrivacy

		},
		handleCheckAll2() {
			this.checkTerms
			this.checkPrivacy

		},

		// check all
		handleCheckAll() {
			if (this.checkAll) {
				this.checkTerms = true
				this.checkPrivacy = true
			} else {
				this.checkTerms = false
				this.checkPrivacy = false
			}
		},

		// next
		next() {
			if (this.checkAll) {
				let agreeDate = Date.now()
				this.SET_TERMS(agreeDate)
					let terms = { "TERMS_OF_SERVICE" : 385,"PRIVACY_STATEMENT" : 382 }
					memberApi.termsAgree({terms}).then((response) => {
						if(response.data.data === true) {
							this.checkSignInStatus()
						}
					}).catch((err) => {
            this.login();
					})

			}else {
				this.$snackOpen({
					contents:this.$t('946'), //모든 약관에 동의해 주세요.
					btnDisplay: ''
				}).then(() => {})
			}
		},
		checkSignInStatus() {
      let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck();
      loginAuth.then((response) => {
					let responseData = response.data.data;
					if (this.isIdpService) {
						loginApi.setAuthInHeader(responseData.token);
					}
					this.MUTATION_USER_DATA(responseData)
                    this.checkUser();
        }).catch((err) => {
					const responseData = err.response.data.meta;
					if (responseData.errCode === 1201) {
						// 관리자 승인 대기중(Waiting for administrator approval)
						// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
						//this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})
						this.$alert({
						title: this.$t("779"), //가입 승인 대기 상태입니다.
						content:
							this.$t("780") +
							"<br>" +
							this.$t("781", {
							str:
								'<a href="mailto:' +
								BRAND_MANAGER_EMAIL +
								'">' +
								BRAND_MANAGER_EMAIL +
								"</a>",
							}) +
							"<br>" +
							this.$t("782", {
							str:
								'<a href="tel:' +
								BRAND_MANAGER_PHONE +
								'">' +
								BRAND_MANAGER_PHONE +
								"</a>",
							}),
						accept: this.$t("783"),
						})
						.then(() => {})
						.catch(() => {});
					} else if (responseData.errCode === 1202) {
						this.$alert({
						title: this.$t("779"), //가입 승인 대기 상태입니다.
						content:
							this.$t("780") +
							"<br>" +
							this.$t("781", {
							str:
								'<a href="mailto:' +
								BRAND_MANAGER_EMAIL +
								'">' +
								BRAND_MANAGER_EMAIL +
								"</a>",
							}) +
							"<br>" +
							this.$t("782", {
							str:
								'<a href="tel:' +
								BRAND_MANAGER_PHONE +
								'">' +
								BRAND_MANAGER_PHONE +
								"</a>",
							}),
						accept: this.$t("783"),
						})
						.then(() => {})
						.catch(() => {});
					} else if (responseData.errCode === 1204) {
						this.$alert({
						title: this.$t("1482"), //가입 승인 대기 상태입니다.
						content:
							this.$t("1483") +
							"<br>" +
							this.$t("1484") +
							": " +
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>" +
							"<br>" +
							this.$t("1485") +
							": " +
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						accept: this.$t("1486"),
						})
						.then(() => {})
						.catch(() => {});
					} else if (responseData.errCode === 1205) {
						this.$alert({
						title: this.$t("1914"), //가입 승인 대기 상태입니다.
						content:
							this.$t("1915") +
							" " +
							this.$t("1916") +
							"<br>" +
							this.$t("1917", {
							str:
								'<a href="mailto:' +
								BRAND_MANAGER_EMAIL +
								'">' +
								BRAND_MANAGER_EMAIL +
								"</a>",
							}) +
							"<br>" +
							this.$t("1918", {
							str:
								'<a href="tel:' +
								BRAND_MANAGER_PHONE +
								'">' +
								BRAND_MANAGER_PHONE +
								"</a>",
							}),
						accept: this.$t("1919"),
						})
						.then(() => {})
						.catch(() => {});
					} else if (responseData.errCode === 1105) {
						this.$alert({
						content: this.$t("1875"),
						accept: this.$t("1876"),
						})
						.then(() => {})
						.catch(() => {});
					} else if (responseData.errCode === 1335) {
						//아이디 계정 일시 정지(Suspend Account)
						// 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
						this.$snackOpen({
						contents: this.$t("323"),
						btnDisplayYN: false,
						}).then(() => {});
					} else {
            this.login();
					}
			});
		},
		signOutFirebase() {
			firebase.auth().signOut();
		},
	}
}
</script>
<style scoped>
.mdc-form-field > label {
    padding-left: 0px!important;
}
html[dir="rtl"] .mdc-form-field > label {
    padding-right: 0px!important;
}
.cursor--pointer{
	cursor: pointer;
}
</style>
